export let LauncherEvent = /*#__PURE__*/function (LauncherEvent) {
  /**
   * Show/hide your custom launcher with the triggered boolean value.
   */
  LauncherEvent["HANDLE_CUSTOM_LAUNCHER_VISIBILITY"] = "EVENT_HANDLE_CUSTOM_LAUNCHER_VISIBILITY";
  return LauncherEvent;
}({});
//# sourceMappingURL=Listener.js.map